/* assets/upsell-core.js */
(function () {
  "use strict";

  const CORE_NS = "CordsUpsell";

  // If already loaded, don't re-define (defensive for theme editor/preview).
  if (window[CORE_NS]) return;

  function toNumberOrNull(x) {
    const n = Number(x);
    return Number.isFinite(n) ? n : null;
  }

  function getActiveCurrency() {
    return (
      window.Shopify?.currency?.active ||
      window.Shopify?.currency?.shop_currency ||
      null
    );
  }

  function safeString(x) {
    const s = x == null ? "" : String(x);
    const trimmed = s.trim();
    return trimmed.length ? trimmed : null;
  }

  function normalizeItem(item) {
    if (!item || typeof item !== "object") return null;

    const out = {
      item_id: safeString(item.item_id),
      item_name: safeString(item.item_name),
      item_variant: safeString(item.item_variant),
      item_sku: safeString(item.item_sku),
      price: typeof item.price === "number" ? item.price : null,
      quantity:
        typeof item.quantity === "number" && Number.isFinite(item.quantity)
          ? item.quantity
          : null,
    };

    // Remove null/undefined keys to keep payload lean
    Object.keys(out).forEach((k) => out[k] == null && delete out[k]);
    return Object.keys(out).length ? out : null;
  }

  function normalizeItems(items) {
    if (!Array.isArray(items)) return null;
    const norm = items
      .map(normalizeItem)
      .filter(Boolean);

    return norm.length ? norm : null;
  }

  function publish(eventName, customData) {
    try {
      if (!window.Shopify?.analytics?.publish) return false;
      window.Shopify.analytics.publish(eventName, customData || {});
      return true;
    } catch {
      return false;
    }
  }

  /**
   * Standard payload contract for upsell add-to-cart.
   * This is the contract you can reuse later from checkout extensions too.
   */
  function publishUpsellAddToCart(data) {
    const currency = data.currency || getActiveCurrency();

    const payload = {
      meta_id: safeString(data.meta_id),
      source: safeString(data.source) || "upsell",
      component: safeString(data.component),
      placement: safeString(data.placement),
      trigger: safeString(data.trigger),

      color: safeString(data.color),

      variant_id: safeString(data.variant_id),
      item_name: safeString(data.item_name),

      currency: safeString(currency),
      value: typeof data.value === "number" ? data.value : null,
      items: normalizeItems(data.items),

      // Optional passthrough bag (future proof)
      extra: data.extra && typeof data.extra === "object" ? data.extra : undefined,
    };

    // Drop empty keys
    Object.keys(payload).forEach((k) => payload[k] == null && delete payload[k]);
    if (payload.extra === undefined) delete payload.extra;

    return publish("cords:upsell_add_to_cart", payload);
  }

  // Public API
  window[CORE_NS] = {
    toNumberOrNull,
    getActiveCurrency,
    publish,
    publishUpsellAddToCart,
  };
})();